import { FeatureCollection } from 'geojson';
import { GeoJSONSource } from 'mapbox-gl';

import { Mote } from '../models';

/**
 * Utility functions to convert data such as motes to GeoJson types that are compatible with Mapbox
 */
export class MapUtils {

    public static readonly DefaultClusterMaxZoom = 13;

    /**
     * Generate a GeoJson feature collection from a array of motes
     */
    public static genFeatureCollection(motes: Mote[] = [], getRoutes: boolean, hideRoutes: boolean = false): FeatureCollection {
        return {
            "type": "FeatureCollection",
            "features": motes.map((mote: Mote) => {
                return {
                    type: 'Feature',
                    "geometry": mote.getGeometry(getRoutes, hideRoutes),
                    "properties": mote.properties
                };
            })
        };
    }

    /**
     *  Generate a geoJson source object containing the given feature collection.
     *  Optionally add clustering options (zoom, radius etc.) for feature clustering on the map
     */
    public static genGeoJsonSource(featureCollection: Array<any> = [], cluster: boolean = false, clusterMaxZoom: number = this.DefaultClusterMaxZoom, clusterRadius: number = 32): GeoJSONSource {
        let source: any = {
            "type": "geojson",
            "data": {
                "type": "FeatureCollection",
                "features": featureCollection
            }
        };

        if(cluster) {
            source.cluster = true;
            source.clusterMaxZoom = clusterMaxZoom;
            source.clusterRadius = clusterRadius;
        }
        return source;
    };


    /**
     * Calculate width of circle in pixels taking radius in meter and current latitude (Coords.lat)
     */
    public static metersToPixelsAtMaxZoom(meters: number, latitude: number) {
        // From https://stackoverflow.com/questions/37599561/drawing-a-circle-with-the-radius-in-miles-meters-with-mapbox-gl-js
        return meters / 0.075 / Math.cos(latitude * Math.PI / 180);
    }

    /**
     * Calc distance in meters between two geographical points
     */
    public static calcDistance(lat1: number, lon1: number, lat2: number, lon2: number) {
        // From http://www.geodatasource.com/developers/javascript
        let radlat1 = Math.PI * lat1 / 180;
        let radlat2 = Math.PI * lat2 / 180;
        let theta = lon1 - lon2;
        let radtheta = Math.PI * theta / 180;
        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        return Math.floor(dist * 1.609344 * 1000);
    }
}
